import { BaseService } from '@services/BaseService'

const resource = 'sharing/export'

class ExportService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const exportService = new ExportService()
